import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationError, NavigationCancel, Event as NavigationEvent } from '@angular/router';
import { NgProgressComponent, NgProgress } from 'ngx-progressbar';
import { EmitterService } from './utils/services/emitter.service';
import { DataHelper, UrlHelper } from './utils/helpers';
import { TranslationService } from './utils/services/translation.service';
import { AuthService } from './utils/services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../environments/environment';

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit, AfterViewInit {
    @ViewChild(NgProgressComponent) progressBar: NgProgressComponent;

    private favicon: any;
    public theme: any;
    //loader
    // Inicia en true para que el loader sea visible desde el primer render
    // (antes arrancaba en false y la pantalla quedaba en blanco al cargar la vista)
    isLoading: boolean = true;
    private authTokenProcessed: boolean = false;
    private appUrl: string = '';

    constructor(
        private router: Router,
        private progress: NgProgress,
        private emitterService: EmitterService,
        private translate: TranslationService,
        private authService: AuthService,
        private cookieService: CookieService
    ) {
        /* router.events.forEach((event: NavigationEvent) => {
             if (event instanceof NavigationStart) {
                 this.progressBar.start();
             }
             if (event instanceof NavigationEnd) {
                 this.progressBar.complete();
             }
         });
         translate.setLang('en');*/
        //loader
        // Una sola fuente de verdad para el loader: eventos del router.
        // Evita parpadeos por desincronización con el observable del progress bar.
        // Contador de navegaciones activas: evita parpadeos cuando un guard
        // redirige y dispara una navegación encadenada inmediatamente después
        // del NavigationEnd anterior. El loader se mantiene activo hasta que
        // TODAS las navegaciones pendientes terminen.
        let pendingNavigations = 0;
        let hideTimer: any = null;

        this.router.events.forEach((event: NavigationEvent) => {
            if (event instanceof NavigationStart) {
                pendingNavigations++;
                if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
                this.isLoading = true;
                this.progress.ref().start();
            }
            if (event instanceof NavigationEnd ||
                event instanceof NavigationError ||
                event instanceof NavigationCancel) {
                pendingNavigations = Math.max(0, pendingNavigations - 1);
                this.progress.ref().complete();
                if (pendingNavigations === 0) {
                    // Pequeño delay: si en ese intervalo arranca otra navegación,
                    // cancelamos el apagado y dejamos el loader visible.
                    hideTimer = setTimeout(() => {
                        if (pendingNavigations === 0) {
                            this.isLoading = false;
                        }
                        hideTimer = null;
                    }, 250);
                }
            }
        });

        translate.setLang('en');
    }

    ngOnInit() {
        this.favicon = document.querySelector('#favicon');

        this.emitterService.get('favicon.change').subscribe((data) => {
            if (!DataHelper.isEmpty(data)) {
                this.favicon.href = data;
            }
        });

        // Guardar la ruta actual en sessionStorage en cada navegación para poder
        // restaurarla si el iframe se refresca.
        this.router.events.forEach((event: NavigationEvent) => {
            if (event instanceof NavigationEnd) {
                const url = event.urlAfterRedirects || event.url;
                // No persistir la pantalla de login para evitar quedar atrapado ahí
                if (url && !url.includes('/login')) {
                    sessionStorage.setItem('player_last_route', url);
                }
            }
        });

        // Si hay una ruta guardada y la URL actual es exactamente la raíz,
        // navegar de vuelta a donde estaba el usuario antes del refresh.
        const lastRoute = sessionStorage.getItem('player_last_route');
        const atRoot = window.location.pathname === '/' || window.location.pathname === '';
        if (lastRoute && atRoot) {
            setTimeout(() => this.router.navigateByUrl(lastRoute, { replaceUrl: true }), 0);
        }

        this.appUrl = environment.envVar.MSC_APP_URL.replace(/\/$/, '');
        // ancestorOrigins[0] es siempre el origin del frame padre real, incluso tras recargas
        // internas del iframe (window.location.href). document.referrer no es fiable en ese caso.
        if (window.location.ancestorOrigins && window.location.ancestorOrigins.length > 0) {
            this.appUrl = window.location.ancestorOrigins[0];
        } else if (document.referrer) {
            try {
                this.appUrl = new URL(document.referrer).origin;
            } catch (e) {
                // referrer inválido, se mantiene el valor del environment
            }
        }
        console.log('[PLAYER AppComponent] ngOnInit - appUrl esperado:', this.appUrl, '(referrer:', document.referrer, ')');
        console.log('[PLAYER AppComponent] ¿En iframe?', window.parent !== window);

        window.addEventListener('message', (event) => {
            console.log('[PLAYER AppComponent] message recibido - origin:', event.origin, 'type:', event.data?.type);
            if (event.origin === this.appUrl && event.data?.type === 'auth_token' && event.data.access_token && !this.authTokenProcessed) {
                this.authTokenProcessed = true;
                console.log('[PLAYER AppComponent] auth_token recibido, creando cookies...');
                this.authService.createCookies({
                    access_token: event.data.access_token,
                    refresh_token: event.data.refresh_token
                });
                if (event.data.current_company) {
                    this.cookieService.set('current_company', event.data.current_company, 10, '/', UrlHelper.getDomain(), false, 'Lax');
                    sessionStorage.setItem('current_company', event.data.current_company);
                }
                console.log('[PLAYER AppComponent] cookies creadas OK');
                console.log('[PLAYER AppComponent] token en sessionStorage:', sessionStorage.getItem('token_session') ? 'SÍ' : 'NO');
                // Si el Guard redirigió a login, navegar de vuelta al URL original
                if (window.location.pathname.includes('/login')) {
                    const returnUrl = new URLSearchParams(window.location.search).get('returnUrl');
                    const lastRoute = sessionStorage.getItem('player_last_route');
                    const destination = returnUrl || lastRoute;
                    console.log('[PLAYER AppComponent] navegando a:', destination, '(returnUrl:', returnUrl, '| lastRoute:', lastRoute, ')');
                    setTimeout(() => {
                        if (destination) {
                            this.router.navigateByUrl(destination, { replaceUrl: true });
                        } else {
                            this.router.navigate(['/']);
                        }
                    }, 50);
                }
            } else if (event.data?.type === 'auth_token') {
                if (this.authTokenProcessed) {
                    console.log('[PLAYER AppComponent] auth_token ignorado - ya fue procesado anteriormente');
                } else {
                    console.warn('[PLAYER AppComponent] auth_token rechazado - origin no coincide. origin:', event.origin, 'esperado:', this.appUrl);
                }
            }
        });

        // Notificar al app padre que el player está listo para recibir el token
        if (window.parent !== window) {
            console.log('[PLAYER AppComponent] enviando player_ready al padre, targetOrigin:', this.appUrl);
            window.parent.postMessage({ type: 'player_ready' }, this.appUrl);

            // El scroll lo maneja el app padre: como es cross-origin no conoce la
            // altura del curso, así que se la reportamos para que ajuste el alto del
            // iframe y su contenedor sea el que scrollee (barra visible al borde de
            // la ventana). Reportamos al inicio, en cada navegación y ante cambios
            // de tamaño del contenido (acordeones, carga diferida, etc.).
            this.reportHeightToParent();
            [300, 1000, 2500].forEach((ms) => setTimeout(() => this.reportHeightToParent(), ms));

            if (typeof ResizeObserver !== 'undefined') {
                const ro = new ResizeObserver(() => this.reportHeightToParent());
                ro.observe(document.documentElement);
                if (document.body) { ro.observe(document.body); }
            }
            window.addEventListener('resize', () => this.reportHeightToParent());

            // El wheel sobre el contenido del iframe no se propaga al padre (límite
            // cross-origin), así que lo reenviamos para que el padre desplace su
            // contenedor. Si el cursor está sobre un área con scroll propio (que
            // todavía puede desplazarse), dejamos que esa área lo maneje.
            window.addEventListener('wheel', (e: WheelEvent) => {
                if (this.isInnerScrollable(e.target as Element, e.deltaY)) { return; }
                e.preventDefault();
                window.parent.postMessage(
                    { type: 'player_wheel', deltaX: e.deltaX, deltaY: e.deltaY, deltaMode: e.deltaMode },
                    this.appUrl
                );
            }, { passive: false });

            // En cada navegación interna avisamos al padre la URL actual, para que
            // la persista. Así, si el usuario refresca la página padre, el iframe
            // se reabre exactamente donde estaba y no en la portada del curso.
            this.router.events.forEach((event: NavigationEvent) => {
                if (event instanceof NavigationEnd) {
                    window.parent.postMessage(
                        { type: 'player_route', url: window.location.href },
                        this.appUrl
                    );
                    // Tras navegar, el contenido (y la altura) cambia: re-reportar.
                    this.reportHeightToParent();
                    setTimeout(() => this.reportHeightToParent(), 300);
                }
            });
        }
    }

    /** Mide la altura real del contenido del curso y se la envía al app padre. */
    private reportHeightToParent(): void {
        if (window.parent === window) { return; }
        const height = Math.max(
            document.documentElement ? document.documentElement.scrollHeight : 0,
            document.body ? document.body.scrollHeight : 0
        );
        window.parent.postMessage({ type: 'player_height', height }, this.appUrl);
    }

    /**
     * ¿El elemento (o un ancestro) tiene scroll propio y todavía puede desplazarse
     * en la dirección del wheel? Si es así, no reenviamos al padre y dejamos que
     * ese contenedor interno haga el scroll.
     */
    private isInnerScrollable(target: Element | null, deltaY: number): boolean {
        let node: Element | null = target;
        while (node && node !== document.body && node !== document.documentElement) {
            const oy = getComputedStyle(node).overflowY;
            if ((oy === 'auto' || oy === 'scroll') && node.scrollHeight > node.clientHeight) {
                if (deltaY < 0 && node.scrollTop > 0) { return true; }
                if (deltaY > 0 && node.scrollTop + node.clientHeight < node.scrollHeight) { return true; }
            }
            node = node.parentElement;
        }
        return false;
    }

    ngAfterViewInit() {
        const preloaderElementRef = document.getElementById('preloader');
        if (preloaderElementRef !== null) {
            preloaderElementRef.style['display'] = 'none';
        }
    }


}